
import RegisterNew from '~/pages/_lang/register-complete'
export default RegisterNew
